export default function () {
  const widgetName = 'mainFeature';
  const widgetOpts = mainFeatureOpts;

  const swiperContainers = `
    <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
        <div class="swiper-container">
            <div class="swiper-wrapper"></div>
            <div class="swiper-button-playpause" tabindex="0"></div>
        </div>
  `;

  // Slide Template
  function buildSlideTemplate(slide) {
    let title = `<span class="slide-title">${slide.Title}</span>`;
    let description =
      slide.Description == '' ? '' : `<span class="slide-description">${slide.Description}</span>`;

    const buttons = function (btn1, btn1Text, btn2, btn2Text) {
      if (btn1 || btn2) {
        let btnContainer = $('<div class="button-container"></div>');
        if (btn2) {
          btnContainer.append(`<a href="${btn2}" class="button">${btn2Text}</a>`);
        }
        if (btn1) {
          btnContainer.append(`<a href="${btn1}" class="button">${btn1Text}</a>`);
        }
        return btnContainer.prop('outerHTML');
      } else {
        return '';
      }
    };

    const template = `
      <div class="swiper-slide">
          <img data-src="${slide.ImageWithPath}" class="swiper-lazy swiper-image" alt="${slide.ImageAlternateText}">
            <div class="swiper-content-container">
              <div class="content-wrapper ${slide.URL == null ? 'no-btn' : ''}">
                <div class="text-content">
                  ${title}
                  ${description}
                </div>
               ${buttons(slide.URL, slide.DetailLinkText, slide.PurchaseURL, slide.PurchaseLinkText)}
              </div>
            </div>
      </div>
    `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);

    widgetData.forEach(function (slide) {
      swiperWidgetWrapper.append(buildSlideTemplate(slide));
      if (widgetData.length == 1) {
        $(`#${widgetName} .swiper-content-container`).addClass('single-slide');
        $(`#${widgetName} .swiper-image`).addClass('single-slide');
        $(`#${widgetName} .content-wrapper`).addClass('single-slide');
      }
    });

    const swiperWidget = new Swiper(`#${widgetName} .swiper-container`, {
      speed: 600,
      autoplay: {
        delay: 8000,
      },
      slidesPerView: widgetData.length == 1 ? 1 : 2,
      spaceBetween: 0,
      preloadImages: false,
      watchSlidesProgress: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: widgetData.length == 1 ? 1 : 2,
      },
      a11y: true,
      autoHeight: true,
      loop: widgetData.length > 1,
      watchOverflow: true,
      navigation: {
        nextEl: `#${widgetName} .swiper-button-next`,
        prevEl: `#${widgetName} .swiper-button-prev`,
      },
      breakpoints: {
        1090: {
          slidesPerView: 1,
        },
      },
    });

    $('.swiper-button-playpause').on('click keydown', function (event) {
      if (event.type === 'click' || event.key === 'Enter') {
        if ($(this).hasClass('paused')) {
          $(this).removeClass('paused');
          swiperWidget.autoplay.start();
        } else {
          $(this).addClass('paused');
          swiperWidget.autoplay.stop();
        }
      }
    });
  }

  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    }
  });
}
